var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-end position-absolute w-100 h-100 cover-overlay flex-wrap"},[_c('TournamentsListPinnedItem',{staticClass:"w-100 h-100",attrs:{"tournament":_vm.account}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }